import { create } from 'zustand'

import type { WidgetDraft } from '@/features/mitra/api/dashboard'

/**
 * A chat proposal handed to Analytics Studio to edit before it is saved
 * (owner, 2026-10-20: "where is the option to change it if wrong?"). The
 * confirm card puts the proposed widgets here and opens their dashboard; the
 * dashboard opens its editor on each in turn, saves what the reader settles
 * on over HTTP, and once every one is saved sets the chat's proposal aside,
 * so the two never both land. Cancelling the editor leaves the proposal as
 * it was, still the reader's to Save in the chat.
 */
export interface Handoff {
  dashboardId: string
  drafts: WidgetDraft[]
  /** The chat's pending proposal, discarded once the drafts are saved here. */
  proposalId: string | null
}

interface HandoffState {
  handoff: Handoff | null
  /** Chat proposals whose widgets were saved here instead: their card says so. */
  savedInStudio: readonly string[]
  markSaved: (proposalId: string) => void
  handOff: (handoff: Handoff) => void
  /** The next draft, or null once every one is done; clears itself at the end. */
  next: () => void
  clear: () => void
}

export const useStudioHandoff = create<HandoffState>((set) => ({
  handoff: null,
  savedInStudio: [],
  markSaved: (proposalId) => {
    set((now) => ({ savedInStudio: [...now.savedInStudio, proposalId] }))
  },
  handOff: (handoff) => {
    set({ handoff: handoff.drafts.length > 0 ? handoff : null })
  },
  next: () => {
    set((now) =>
      now.handoff && now.handoff.drafts.length > 1
        ? { handoff: { ...now.handoff, drafts: now.handoff.drafts.slice(1) } }
        : { handoff: null },
    )
  },
  clear: () => {
    set({ handoff: null })
  },
}))
